export const WHATSAPP_TEMPLATES_QUERY_KEY = 'whatsappTemplates';
